import Vue from 'vue'
import VueSession from 'vue-session'
Vue.use(VueSession);
import App from './App.vue'
import VueResource from 'vue-resource'
import VueRouter from 'vue-router'
import VueX from 'vuex'
import router from './router'
import { sync } from 'vuex-router-sync'
import store from './store'
import '@/assets/css/fontawesome.css';
import '@/assets/css/solid.css';
import '@/assets/css/duotone.css';
import '@/assets/css/brands.css';


import UUID from "vue-uuid";
Vue.use(UUID);

import globalVars from "@/plugins/globalVars";
Vue.use(globalVars)

// Import the Auth0 configuration
// import { domain, clientId, audience} from "../auth_config.json";

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

// import Auth0Lock from 'auth0-lock';

/*import VueHead from 'vue-head'
Vue.use(VueHead)*/

/*import VueTour from 'vue-tour'
Vue.use(VueTour)*/

import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

/*require('vue-tour/dist/vue-tour.css')
import './components/css/overrides/vuetour.css'*/

import VueMeta from 'vue-meta'
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})

import LoadScript from 'vue-plugin-load-script';
Vue.use(LoadScript);
Vue.loadScript("https://cdn.auth0.com/js/auth0/9.11/auth0.min.js")

Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(VueX)

sync(store, router);

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
Vue.$cookies.config('1y')


import VueLazyImageLoading from 'vue-lazy-image-loading';
Vue.use(VueLazyImageLoading)

Vue.config.productionTip = false

String.prototype.decodeEscapeSequence = function() {
  return this.replace(/\\x([0-9A-Fa-f]{2})/g, function() {
    return String.fromCharCode(parseInt(arguments[1], 16));
  });
};

/*
let options = {
  container: 'login-container',
  auth: {
    redirect: false,
    redirectUrl: location.origin,
    responseType: 'token',
    audience: audience,
    sso: true,
  },
  theme: {
    logo: "https://learnandwatch.s3.eu-west-3.amazonaws.com/Logo_white_background.png",
    primaryColor: '#52BBF9',
  },
  languageDictionary: {
    title: "Se connecter",
    error: {
      login: {},
      signUp: {
        invalid_password: 'Le mot de passe est invalide.',
        'lock.fallback': "We're sorry, something went wrong when attempting to sign up.",
        password_dictionary_error: 'Le mot de passe est trop commun.',
        password_no_user_info_error: 'Le mot de passe est trop facile à deviner.',
        password_strength_error: 'Le mot de passe est trop faible.',
        user_exists: 'Ce compte existe déjà.',
        username_exists: 'Ce pseudo existe déjà.',
        social_signup_needs_terms_acception: 'Tu dois accepter les conditions avant de continuer.',
        'lock.invalid_email_password': 'Le mot de passe ou le mail est invalide.',
      }
    }
  },
  language: 'fr',
  initialScreen: 'signUp',
  autoclose: true
}
export let lock = new Auth0Lock(clientId, domain, options);
*/

new Vue({
  router: router,
  store: store,
  render: h => h(App),
}).$mount('#app')
